module.exports = __webpack_public_path__ + "img/objective.8e99f54e.jpg";